<app-side-menu>
  <div class="customer-view-content">
    <div class="view-header">
      <div class="header-content">
        <div class="header-left">
          <h1 class="page-title">
            <i class="fas fa-user-group me-3"></i>
            Visualizar Cliente
          </h1>
          <p class="page-subtitle" *ngIf="customer">{{ customer.name }}</p>
        </div>
        <div class="header-actions">
          <ng-container *appHasPermission="'Customers.Edit'">
            <button *ngIf="customer" type="button" class="btn btn-primary" (click)="goToEdit()">
              <i class="fas fa-edit me-2"></i>
              Editar
            </button>
          </ng-container>
          <button type="button" class="btn btn-secondary" (click)="goBack()">
            <i class="fas fa-arrow-left me-2"></i>
            Voltar
          </button>
        </div>
      </div>
    </div>

    <app-loading [show]="isLoading" message="Carregando cliente..."></app-loading>

    <div *ngIf="error" class="alert alert-danger">
      <i class="fas fa-exclamation-circle me-2"></i>
      {{ error }}
    </div>

    <div *ngIf="!isLoading && !error && customer" class="view-card">
      <app-form-shell
        [tabs]="availableTabs"
        [activeTab]="activeTab"
        (tabChange)="selectTab($event)">
      </app-form-shell>

      <!-- Seção: Identificação -->
      <section class="view-section" *ngIf="activeTab === 'identification'">
        <h3 class="section-title">
          <i class="fas fa-building me-2"></i>
          Identificação
        </h3>
        <div class="detail-grid">
          <div class="detail-item">
            <label>Tipo de Pessoa</label>
            <div class="readonly-value">{{ customer.personType === 'Fisica' ? 'Física' : 'Jurídica' }}</div>
          </div>
          <div class="detail-item">
            <label>{{ isPF ? 'Nome Completo' : 'Razão Social' }}</label>
            <div class="readonly-value">{{ display(customer.name) }}</div>
          </div>
          <div class="detail-item" *ngIf="!isPF">
            <label>Nome Fantasia</label>
            <div class="readonly-value">{{ display(customer.tradeName) }}</div>
          </div>
          <div class="detail-item">
            <label>{{ isPF ? 'CPF' : 'CNPJ' }}</label>
            <div class="readonly-value">{{ formatDocument(customer.documentNumber) }}</div>
          </div>
          <div class="detail-item">
            <label>{{ isPF ? 'RG' : 'Inscrição Estadual' }}</label>
            <div class="readonly-value">{{ display(customer.stateRegistration) }}</div>
          </div>
          <div class="detail-item">
            <label>Número da CNH</label>
            <div class="readonly-value">{{ display(customer.driverLicenseNumber) }}</div>
          </div>
          <div class="detail-item">
            <label>Validade da CNH</label>
            <div class="readonly-value">{{ formatDate(customer.driverLicenseExpiryDate) }}</div>
          </div>
        </div>
      </section>

      <!-- Seção: Contato -->
      <section class="view-section" *ngIf="activeTab === 'contact'">
        <h3 class="section-title">
          <i class="fas fa-address-book me-2"></i>
          Informações de Contato
        </h3>
        <div class="detail-grid">
          <div class="detail-item">
            <label>E-mail do Cliente</label>
            <div class="readonly-value">{{ display(customer.email) }}</div>
          </div>
          <div class="detail-item full-width">
            <label>Portal de Contatos</label>
            <div class="readonly-value" *ngIf="displayContacts.length === 0">-</div>
            <div class="contacts-grid" *ngIf="displayContacts.length > 0">
              <article class="contact-card" *ngFor="let contact of displayContacts">
                <div class="contact-card-header">
                  <span class="contact-type">{{ display(contact.contactType) }}</span>
                  <span class="contact-default" *ngIf="contact.isDefault">Padrão</span>
                </div>
                <div class="contact-name">{{ display(contact.contactName) }}</div>
                <div class="contact-row">
                  <i class="fas fa-phone"></i>
                  <span>{{ formatPhone(contact.phoneNumber) }}</span>
                </div>
                <div class="contact-row" *ngIf="contact.secondaryPhoneNumber">
                  <i class="fas fa-phone-volume"></i>
                  <span>{{ formatPhone(contact.secondaryPhoneNumber) }}</span>
                </div>
              </article>
            </div>
          </div>
          <div class="detail-item">
            <label>Categoria</label>
            <div class="readonly-value">{{ display(customer.customerCategory) }}</div>
          </div>
          <div class="detail-item full-width">
            <label>Logradouro</label>
            <div class="readonly-value">{{ display(customer.street) }}</div>
          </div>
          <div class="detail-item">
            <label>Número</label>
            <div class="readonly-value">{{ display(customer.number) }}</div>
          </div>
          <div class="detail-item">
            <label>Complemento</label>
            <div class="readonly-value">{{ display(customer.complement) }}</div>
          </div>
          <div class="detail-item">
            <label>Bairro</label>
            <div class="readonly-value">{{ display(customer.neighborhood) }}</div>
          </div>
          <div class="detail-item">
            <label>Cidade</label>
            <div class="readonly-value">{{ display(customer.city) }}</div>
          </div>
          <div class="detail-item">
            <label>Estado</label>
            <div class="readonly-value">{{ display(customer.state) }}</div>
          </div>
          <div class="detail-item">
            <label>CEP</label>
            <div class="readonly-value">{{ display(customer.zipCode) }}</div>
          </div>
        </div>
      </section>

      <!-- Seção: Status e Observações -->
      <section class="view-section" *ngIf="activeTab === 'status'">
        <h3 class="section-title">
          <i class="fas fa-clipboard-list me-2"></i>
          Status e Observações
        </h3>
        <div class="detail-grid">
          <div class="detail-item">
            <label>Ativo</label>
            <div class="readonly-value">{{ display(customer.active) }}</div>
          </div>
          <div class="detail-item full-width">
            <label>Observações</label>
            <div class="readonly-value readonly-multiline">{{ display(customer.notes) }}</div>
          </div>
        </div>
      </section>

      <!-- Seção: Dados Bancários -->
      <section class="view-section" *ngIf="activeTab === 'payments'">
        <h3 class="section-title">
          <i class="fas fa-credit-card me-2"></i>
          Dados Bancários
        </h3>
        <div class="detail-grid">
          <div class="detail-item">
            <label>Nome do Banco</label>
            <div class="readonly-value">{{ display(customer.bankName) }}</div>
          </div>
          <div class="detail-item">
            <label>Agência</label>
            <div class="readonly-value">{{ display(customer.agency) }}</div>
          </div>
          <div class="detail-item">
            <label>Tipo de Conta</label>
            <div class="readonly-value">{{ display(customer.accountType) }}</div>
          </div>
          <div class="detail-item">
            <label>Número da Conta</label>
            <div class="readonly-value">{{ display(customer.accountNumber) }}</div>
          </div>
          <div class="detail-item">
            <label>Nome do Titular</label>
            <div class="readonly-value">{{ display(customer.accountHolderName) }}</div>
          </div>
          <div class="detail-item">
            <label>Chave PIX</label>
            <div class="readonly-value">{{ display(customer.pixKey) }}</div>
          </div>
        </div>
      </section>

      <!-- Seção: Documentos -->
      <section class="view-section" *ngIf="activeTab === 'documents'">
        <h3 class="section-title">
          <i class="fas fa-paperclip me-2"></i>
          Documentos do Cliente
        </h3>

        <div *ngIf="isLoadingAttachments" class="text-center py-4">
          <span class="spinner-border spinner-border-sm me-2" role="status"></span>
          Carregando documentos...
        </div>

        <div *ngIf="!isLoadingAttachments && attachments.length === 0" class="text-muted">
          <i class="fas fa-info-circle me-1"></i>
          Nenhum documento anexado para este cliente.
        </div>

        <div *ngIf="!isLoadingAttachments && attachments.length > 0" class="documents-table">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Arquivo</th>
                <th>Categoria</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let att of attachments">
                <td>
                  <i class="fas fa-file text-success me-1"></i>
                  <a
                    [href]="att.filePath || att.blobUrl"
                    target="_blank"
                    rel="noopener noreferrer">
                    {{ att.originalFileName }}
                  </a>
                </td>
                <td>
                  {{ att.category || '-' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </div>
</app-side-menu>
